import { ApolloClient, InMemoryCache } from '@apollo/client';
import { environment } from '../../environment';

export const cmsClient = new ApolloClient({
  uri: `${environment.CMS_URL}/graphql`,
  cache: new InMemoryCache(),
});
